import { render, staticRenderFns } from "./MapaUbs.vue?vue&type=template&id=69e64b3e&scoped=true"
import script from "./MapaUbs.vue?vue&type=script&lang=js"
export * from "./MapaUbs.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=69e64b3e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e64b3e",
  null
  
)

export default component.exports